module.exports = __webpack_public_path__ + "static/copadoVidA-fe2a8fb63de746af30906e313ebf2b39.mp4";